import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  appear() {
    this.element.classList.add("prevent-swipe")

    const closeButton = this.element.querySelector("[data-close-sidenav]")
    if (closeButton) {
      closeButton.addEventListener("click", () => {
        this.element.classList.remove("prevent-swipe")
      })
    }
  }
}
